import { blockquote, tableSelected, tableScrollableWrapper, tableCellHeader, tableCell, tableCellSelected, tableStyle, listItem, ulDepth1, ulDepth2, ulDepth3, ulDepth4, ulDepth5, ul, olDepth1, olDepth2, olDepth3, olDepth4, olDepth5, ol, nestedListItem, nestedList, paragraph, textLink, heading3, heading2, heading1, textBase, textUnderline, textItalic, textCode, textStrikethrough, textBold, root } from './styles/base.mjs';

const BASE_THEME = {
  root: root.className,
  text: {
    bold: textBold.className,
    strikethrough: textStrikethrough.className,
    code: textCode.className,
    italic: textItalic.className,
    underline: textUnderline.className,
    base: textBase.className
  },
  heading: {
    h1: heading1.className,
    h2: heading2.className,
    h3: heading3.className
  },
  link: textLink.className,
  paragraph: paragraph.className,
  list: {
    nested: {
      list: nestedList.className,
      listitem: nestedListItem.className
    },
    ol: ol.className,
    olDepth: [
      olDepth1.className,
      olDepth2.className,
      olDepth3.className,
      olDepth4.className,
      olDepth5.className
    ],
    ul: ul.className,
    ulDepth: [
      ulDepth1.className,
      ulDepth2.className,
      ulDepth3.className,
      ulDepth4.className,
      ulDepth5.className
    ],
    listitem: listItem.className
  },
  table: tableStyle.className,
  tableCellSelected: tableCellSelected.className,
  tableCell: tableCell.className,
  tableCellHeader: tableCellHeader.className,
  tableScrollableWrapper: tableScrollableWrapper.className,
  tableSelected: tableSelected.className,
  quote: blockquote.className
};

export { BASE_THEME };
//# sourceMappingURL=base.mjs.map
